import React, { useState, useEffect } from "react";
import "./JoinUs.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { NavLink } from "react-router-dom";

function JobsList() {
  const [jobs, setJobs] = useState([]);
  const { t } = useTranslation();
  var lang = i18n.language;

  document.title = t("page-title.joinus");

  var file;
  if (lang.includes("sl_si")) {
    file = "jobs-sl_si.json";
  } else if (lang.includes("en_si")) {
    file = "jobs-en_si.json";
  } else if (lang.includes("hr_hr")) {
    file = "jobs-hr_hr.json";
  } else if (lang.includes("de_at")) {
    file = "jobs-de_at.json";
  } else if (lang.includes("de_de")) {
    file = "jobs-de_de.json";
  } else if (lang.includes("en_at")) {
    file = "jobs-en_at.json";
  } else if (lang.includes("de_de")) {
    file = "jobs-de_de.json";
  } else if (lang.includes("en_de")) {
    file = "jobs-en_de.json";
  } else if (lang.includes("_pt")) {
    file = "jobs-en_pt.json";
  }

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/api/${file}`);
        const data = await response.json();
        setJobs(data.jobs);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchJobs();
  }, []);



  return (
    <div class="row cards">
      {jobs.map((job, index) => (
        <div class="col-lg-6" id={index}>
          <NavLink
            to={`${t("url.job-description")}/${index}`}
            className="card-link"
          >
            <div className="card">
              <img
                src={`${process.env.PUBLIC_URL}/images/cards/job-card-trans.png`}
                alt="Job-openings"
              />
              <div className="card-content">
                <h2 className="mb-3">{job.country}</h2>
                <h4>{job.title}</h4>
              </div>
              <div className="readmore">
                <NavLink to={`${t("url.job-description")}/${index}`}>
                  {t("products.readmore")}
                </NavLink>
              </div>
            </div>
          </NavLink>
          <div className="d-flex justify-content-center">
            <div className="card-shadow">
              <img
                src={`${process.env.PUBLIC_URL}/images/cards/shadow.png`}
                alt="shadow card"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const JoinUs = () => {
  const { t } = useTranslation();
  var lang = i18n.language;

  return (
    <div className="UIJoinUs">
      <div className="container-fluid background">
        <div className="bg-image"></div>
        <div className="container">
          <div className="heading">
            <h2>{t("joinus.joinus")}</h2>
            {!lang.includes("_si") && !lang.includes("_pt") && !lang.includes("_at") && !lang.includes("_hr") && (
              <h1>{t("pages.zaposlitev")}</h1>
            )}
            {lang.includes("_si") && <h1>{t("joinus.available-jobs")}</h1>}
            {lang.includes("_pt") && <h1>{t("joinus.available-jobs")}</h1>}
            {lang.includes("_at") && <h1>{t("joinus.available-jobs")}</h1>}
            {lang.includes("_hr") && <h1>{t("joinus.available-jobs")}</h1>}
            {/* {lang.includes("_de") && <h1>{t("joinus.available-jobs")}</h1>} */}
          </div>

          {lang.includes("sl_si") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {lang.includes("hr_hr") && (
            <div className="container content">
              <JobsList />
            </div>
          )}

          {lang.includes("de_at") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {lang.includes("de_de") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {lang.includes("en_at") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {/* {lang.includes("en_si") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {lang.includes("de_de") && (
            <div className="container content">
              <JobsList />
            </div>
          )}
          {lang.includes("en_de") && (
            <div className="container content">
              <JobsList />
            </div>
          )} */}
          {lang.includes("_pt") && (
            <div className="container content">
              <JobsList />
            </div>
          )}

          {!lang.includes("sl_si") && !lang.includes("_pt") && !lang.includes("_at") && !lang.includes("de_de") && !lang.includes("hr_hr") && (
            <div className="container content">
              <div className="text">
                <h4>{t("joinus.interested")}</h4>
                <h4>
                  {t("joinus.sendusemail")}{" "}
                  <span className="enaslov">{t("joinus.email")}</span>{" "}
                  {t("joinus.sendusmail2")}
                </h4>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
